import { LayoutAuth, LayoutDefault, RouteWrapper } from "@/components/layouts";
import { AUTH_TYPE } from "@/util/utils";

export const publicRoute = [
  {
    path: "*",
    component: () => import("@/views/error/NotFound.vue"),
  },
  {
    path: "/404",
    name: "404",
    meta: {
      title: "Not Found",
    },
    component: () => import("@/views/error/NotFound.vue"),
  },
  {
    path: "/auth",
    component: LayoutAuth,
    meta: {
      title: "Login",
    },
    redirect: "/auth/login",
    hidden: true,
    children: [
      {
        path: "login",
        name: "login",
        meta: {
          title: "登录",
        },
        component: () => import("@/views/auth/LoginPage.vue"),
      },
    ],
  },
  {
    path: "/500",
    name: "500",
    meta: {
      title: "Server Error",
    },
    component: () => import("@/views/error/ErrorPage.vue"),
  },
];

export const protectedRoute = [
  {
    path: "/",
    component: LayoutDefault,
    meta: {
      title: "主页",
      group: "apps",
      icon: "",
    },
    redirect: "/overview",
    children: [
      {
        path: "/overview",
        component: () => import("@/views/TodayOverview.vue"),
        meta: {
          title: "总览",
          icon: "mdi-view-dashboard",
          info: "统计自AF回传的BigQuery数据",
        },
      },
      {
        path: "/marketOverviewChart",
        component: () => import("@/views/MarketOverviewChart.vue"),
        meta: {
          title: "市场总览",
          icon: "mdi-chart-areaspline",
          auth: AUTH_TYPE.MARKET,
        },
      },
      {
        path: "/marketOverviewTable",
        component: () => import("@/views/MarketOverviewTable.vue"),
        meta: {
          title: "市场总览(表格)",
          icon: "mdi-table",
          auth: AUTH_TYPE.MARKET,
        },
      },
      {
        path: "/realtime",
        component: () => import("@/views/database/RealtimePage.vue"),
        meta: {
          title: "实时报表",
          icon: "mdi-timer-sync-outline",
          info: "查询24小时内，按小时聚合数据，页面会自动刷新",
        },
      },
      {
        path: "/retained",
        meta: {
          title: "留存率",
          icon: "mdi-account-reactivate-outline",
        },
        component: () => import("@/views/database/PlayerRetained"),
      },
      {
        path: "/paidRetained",
        meta: {
          title: "付费留存率",
          icon: "mdi-cart",
        },
        component: () => import("@/views/database/PaidRetained.vue"),
      },
      {
        path: "/game",
        component: RouteWrapper,
        redirect: "/game/playTime",
        meta: {
          title: "游戏数据",
          icon: "mdi-cellphone-wireless",
        },
        children: [
          {
            path: "/game/playTime",
            name: "game.playTime",
            meta: {
              title: "人均游玩时长",
            },
            component: () => import("@/views/database/PlayTime.vue"),
          },
          {
            path: "/game/progression",
            name: "game.progression",
            meta: {
              title: "关卡通过率",
            },
            component: () => import("@/views/direct/StageProgression"),
          },
          {
            path: "/game/purchase",
            name: "game.purchase",
            meta: {
              title: "付费项分布",
            },
            component: () => import("@/views/direct/PurchasePage"),
          },
          {
            path: "/game/upgrade",
            name: "game.upgrade",
            meta: {
              title: "升级项分布",
            },
            component: () => import("@/views/direct/UpgradePage"),
          },
          {
            path: "/game/upgradeLevel",
            name: "game.upgradeLevel",
            meta: {
              title: "升级项等级分布",
            },
            component: () => import("@/views/direct/UpgradeLevel"),
          },
        ],
      },
      {
        path: "/ad",
        component: RouteWrapper,
        redirect: "/ad/rewardedDistribution",
        meta: {
          title: "广告数据",
          icon: "mdi-advertisements",
        },
        children: [
          {
            path: "/ad/rewardedDistribution",
            name: "ad.rewardedDistribution",
            meta: {
              title: "激励广告分布",
            },
            component: () => import("@/views/direct/RewardedDistribution"),
          },
          {
            path: "/ad/deviation",
            name: "ad.deviation",
            meta: {
              title: "激励广告标准差",
            },
            component: () => import("@/views/direct/AdDeviation"),
          },
          {
            path: "/ad/rewardedAndInterstitial",
            name: "ad.rewardedAndInterstitial",
            meta: {
              title: "激励&插屏广告数",
              info: "计算平均广告数时，会基于同期群新增人数与当天广告数进行计算。",
            },
            component: () => import("@/views/database/RewardedAndInterstitial"),
          },
          {
            path: "/ad/rewardedAndInterstitialRetained",
            name: "ad.rewardedAndInterstitialRetained",
            meta: {
              title: "激励&插屏广告数(日活)",
              info: "计算平均广告数时，会基于当天的留存人数与广告数进行计算。",
            },
            component: () =>
              import("@/views/database/RewardedAndInterstitialRetained"),
          },
          {
            path: "/ad/adRevenue",
            name: "ad.adRevenue",
            meta: {
              title: "平均广告收入",
            },
            component: () => import("@/views/database/AdRevenue"),
          },
        ],
      },
      {
        path: "/iaaiap",
        meta: {
          title: "IAA & IAP报表",
          icon: "mdi-currency-usd",
          info: "统计自AF回传的BigQuery数据",
        },
        component: () => import("@/views/database/IaaAndIapPage"),
      },
      {
        path: "/roi",
        meta: {
          title: "ROI报表",
          icon: "mdi-currency-usd",
          auth: AUTH_TYPE.MARKET,
          info: "统计自各个广告平台API聚合后保存在AWS S3的数据",
        },
        component: () => import("@/views/database/RoiPage"),
      },
      {
        path: "/dailyActiveRoi",
        meta: {
          title: "ROI(日活)报表",
          icon: "mdi-currency-usd",
          auth: AUTH_TYPE.MARKET,
          info: "Cost数据统计自各个广告平台API聚合后保存在AWS S3的数据\n收入数据统计自AF回传的BigQuery数据",
        },
        component: () => import("@/views/database/DailyActiveRoi"),
      },
      {
        path: "/skanCostRoi",
        meta: {
          title: "ROI(日活)报表-SKAN",
          icon: "mdi-currency-usd",
          auth: AUTH_TYPE.MARKET,
        },
        component: () => import("@/views/database/SkanCostRoi.vue"),
      },
      {
        path: "/skaReport",
        meta: {
          title: "SkaReport",
          icon: "mdi-currency-usd",
          auth: AUTH_TYPE.MARKET,
        },
        component: () => import("@/views/database/SkaReportPage.vue"),
      },
      {
        path: "/asset",
        meta: {
          title: "广告素材报表",
          icon: "mdi-currency-usd",
          auth: AUTH_TYPE.MARKET,
        },
        component: () => import("@/views/database/AssetPage"),
      },
      // {
      //   path: "/weekReport",
      //   meta: {
      //     title: "周报&月报",
      //     icon: "mdi-file-table-outline",
      //     auth: AUTH_TYPE.MARKET,
      //   },
      //   component: () => import("@/views/WeekReport"),
      // },
      {
        path: "/analytics",
        component: RouteWrapper,
        redirect: "/analytics/p3",
        meta: {
          title: "数据洞察",
          icon: "mdi-database-eye",
          auth: AUTH_TYPE.MARKET,
        },
        children: [
          {
            path: "/analytics/p1",
            name: "analytics.p1",
            meta: {
              title: "版本对比",
            },
            component: () => import("@/views/analytics/P1"),
          },
          {
            path: "/analytics/p3",
            name: "analytics.p3",
            meta: {
              title: "回收趋势",
            },
            component: () => import("@/views/analytics/P3"),
          },
          {
            path: "/analytics/p4",
            name: "analytics.p4",
            meta: {
              title: "汇总数据",
            },
            component: () => import("@/views/analytics/P4"),
          },
          {
            path: "/analytics/p5",
            name: "analytics.p5",
            meta: {
              title: "素材趋势",
            },
            component: () => import("@/views/analytics/P5"),
          },
        ],
      },
      {
        path: "/projectOverview",
        meta: {
          title: "项目总览",
          icon: "mdi-file-table-outline",
          auth: AUTH_TYPE.ADMIN,
        },
        component: () => import("@/views/database/ProjectOverview.vue"),
      },
    ],
  },
  {
    path: "/management",
    component: LayoutDefault,
    meta: {
      title: "管理",
      icon: "",
    },
    redirect: "/management/project",
    children: [
      {
        path: "/management/project",
        name: "projectManagement",
        meta: {
          title: "项目管理",
          auth: AUTH_TYPE.SUPER_ADMIN,
        },
        component: () => import("@/views/auth/ProjectManagement"),
      },
      {
        path: "/management/auth",
        name: "authManagement",
        meta: {
          title: "权限管理",
          auth: AUTH_TYPE.SUPER_ADMIN,
        },
        component: () => import("@/views/auth/AuthManagement"),
      },
      {
        path: "/management/testUser",
        name: "testUserManagement",
        meta: {
          title: "测试用户&版本管理",
          auth: AUTH_TYPE.ADMIN,
        },
        component: () => import("@/views/auth/TestManagement"),
      },
      {
        path: "/management/attribution",
        name: "attributionManagement",
        meta: {
          title: "概率归因渠道管理",
          auth: AUTH_TYPE.ADMIN,
        },
        component: () => import("@/views/auth/AttributeManagement.vue"),
      },
      {
        path: "/management/task",
        name: "runTask",
        meta: {
          title: "执行任务",
          auth: AUTH_TYPE.ADMIN,
        },
        component: () => import("@/views/auth/RunTaskPage"),
      },
    ],
  },
];
